import { render, staticRenderFns } from "./VersionsList.vue?vue&type=template&id=787e2d87&scoped=true"
import script from "./VersionsList.vue?vue&type=script&lang=js"
export * from "./VersionsList.vue?vue&type=script&lang=js"
import style0 from "./VersionsList.vue?vue&type=style&index=0&id=787e2d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787e2d87",
  null
  
)

export default component.exports